import type { FC, ReactElement } from 'react';
import { placeholderLikeClasses } from 'src/components/form/styles';

type Props = {
  label?: string | ReactElement;
};

export const EmptyValue: FC<Props> = ({ label = '--' }) => (
  <span className={placeholderLikeClasses}>{label}</span>
);
